import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import type { FC } from 'react';

interface ConfirmPaymentProp {
    title: string | '';
    content: string | '' | JSX.Element;
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const ConfirmPayment: FC<ConfirmPaymentProp> = (props) => {
    const { open, onClose, onConfirm, title, content, ...other } = props;
    return (
        <Dialog open={open} onClose={onClose} {...other}>
            <DialogContent>
                <Box sx={{ display: 'flex' }}>
                    <Avatar
                        sx={{
                            backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
                            color: `success.main`,
                            mr: 2,
                        }}
                    >
                        <HelpOutlineIcon />
                    </Avatar>
                    <Box>
                        <Typography color="textPrimary" variant="h5">
                            {title}
                        </Typography>
                        {content}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button color="primary" sx={{ mr: 1 }} variant="outlined" onClick={onClose}>
                    Close
                </Button>
                <Button
                    sx={{ backgroundColor: 'error.main', '&:hover': { backgroundColor: 'error.dark' } }}
                    variant="contained"
                    onClick={onConfirm}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmPayment;

